// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/speech.js';

import { paths } from '../generated/speech';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('speech', Original, paths);
